import React, { useState, useEffect } from "react";
import Search from "./Search";
import StudentsCard from "./StudentsCard";

const StudentsList = ({ studentsData }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleChange = event => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    const results = studentsData.filter(student => {
      return (
        student.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        student.lastName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
    setSearchResults(results);
  }, [searchTerm]);
  return (
    <>
      <div className="hatchway-container">
        <Search
          handleChange={handleChange}
          searchTerm={searchTerm}
          searchBy="name"
        />
        {/* <Search handleChange={handleChange} tagSearchTerm={tagSearchTerm} searchBy="tag" /> */}
        {searchTerm ? (
          <StudentsCard results={searchResults} />
        ) : (
          <StudentsCard results={studentsData} />
        )}
      </div>
    </>
  );
};

export default StudentsList;
